import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';

export const ManualDataEntryRoutes: Route = {
    path: 'manual-data-entry',
    data: { title: 'manual-data-entry' },
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: 'inflation-values',
        },
        {
            path: 'inflation-values',
            loadComponent: () =>
                import('./inflation-values/inflation-values.component').then((m) => m.InflationValuesComponent),
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
            data: { title: 'inflation-values' },
        },
        {
            path: 'agricultural-irrigation-electricity-price',
            loadComponent: () =>
                import('./agricultural-irrigation-electricity-price/agricultural-irrigation-electricity-price.component').then((m) => m.AgriculturalIrrigationElectricityPriceComponent),
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
            data: { title: 'agricultural-irrigation-electricity-price' },
        },
        {
            path: 'fertilizer-registration-certificate-info',
            loadComponent: () =>
                import('./fertilizer-registration-certificate-info/fertilizer-registration-certificate-info.component').then((m) => m.FertilizerRegistrationCertificateInfoComponent),
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
            data: { title: 'fertilizer-registration-certificate-info' },
        },
    ],
};
